import { useMemo } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AttendanceStatusPill, ATTENDANCE_STATUSES, ATTENDANCE_STATUS_ORDER } from "@/components/AttendanceStatusPill";
import { MONTHS_ID } from "@/components/inputs";
import { countAttendanceByStatus } from "@/lib/attendanceRecap";

export function AttendanceMonthlyRecap({ history, month, year }) {
  const counts = useMemo(() => countAttendanceByStatus(history), [history]);
  const periodLabel = `${MONTHS_ID[(month || 1) - 1]} ${year}`;

  return (
    <section aria-label={`Rekap kehadiran bulan ${periodLabel}`}>
      <Card className="p-4 sm:p-6 space-y-4">
        <h3 className="font-heading text-lg font-bold">Rekap Kehadiran · {periodLabel}</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {ATTENDANCE_STATUS_ORDER.map((status) => (
            <div
              key={status}
              aria-label={`${ATTENDANCE_STATUSES[status].label}: ${counts[status]} hari`}
              data-testid={`recap-${status}`}
              className={`rounded-lg border p-3 space-y-2 text-center flex flex-col items-center ${ATTENDANCE_STATUSES[status].className}`}
            >
              <div className="w-full min-w-0 flex justify-center">
                <AttendanceStatusPill status={status} className="!whitespace-normal text-center !leading-tight !text-[11px] !px-2 !py-1 max-w-full" />
              </div>
              <p className="font-heading text-3xl font-bold tabular-nums leading-none">{counts[status]}</p>
              <p className="text-xs text-muted-foreground leading-none">hari</p>
            </div>
          ))}
          {counts.lainnya > 0 && (
            <div
              aria-label={`Lainnya: ${counts.lainnya} hari`}
              data-testid="recap-lainnya"
              className="rounded-lg border border-muted-foreground/30 bg-muted p-3 space-y-2 text-center flex flex-col items-center"
            >
              <div className="w-full min-w-0 flex justify-center">
                <Badge variant="outline" className="border-muted-foreground/30 bg-muted text-muted-foreground font-medium !whitespace-normal text-center !leading-tight !text-[11px] max-w-full">Lainnya</Badge>
              </div>
              <p className="font-heading text-3xl font-bold tabular-nums leading-none">{counts.lainnya}</p>
              <p className="text-xs text-muted-foreground leading-none">hari</p>
            </div>
          )}
        </div>
      </Card>
    </section>
  );
}
